import { ProcesarDatosApi } from "../api/ApiFetch";
const controladortipo = "observacion";



export const AgregarObservacion = async (data) => {
    const url = `${controladortipo}/AgregarObservacion`;
    return await ProcesarDatosApi('POST', url, data);
}

export const ObtenerObservaciones = async (idPersona) => {
    const url = `${controladortipo}/ObtenerObservaciones/${idPersona}`;
    return await ProcesarDatosApi('GET', url);
}

export const EditarObservacion = async (data) => {
    const url = `${controladortipo}/EditarObservacion`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const EliminarObservacion = async (idObservacion) => {
    const url = `${controladortipo}/EliminarObservacion/${idObservacion}`;
    return await ProcesarDatosApi('DELETE', url);
}


